var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _line, _line2, _line3, _line4, _line5, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigidConnectedIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03466 151.69L25.5746 181.001C36.9194 201.106 62.4973 208.143 82.7046 196.719L152.555 157.23C155.442 155.598 156.468 151.947 154.848 149.075C153.227 146.203 149.573 145.198 146.686 146.83L76.8356 186.318C62.4018 194.478 44.1318 189.452 36.0284 175.091L19.4885 145.78",
    stroke: "#222222",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.863 141.776L131.606 124.474L162.54 179.02L131.797 196.321C116.706 204.814 97.5475 199.489 89.0054 184.426C80.4632 169.364 85.7721 150.269 100.863 141.776Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.14 143.509C165.448 151.05 167.851 158.697 168.264 164.955C168.679 171.236 167.089 176.01 163.556 177.983C160.023 179.955 155.066 178.836 149.839 175.242C144.631 171.661 139.247 165.678 134.939 158.137C130.631 150.595 128.228 142.949 127.814 136.691C127.4 130.41 128.99 125.635 132.523 123.663C136.056 121.69 141.013 122.809 146.24 126.404C151.448 129.985 156.831 135.967 161.14 143.509Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.128 139.304C171.579 148.399 174.309 157.938 174.329 165.999C174.348 174.067 171.658 180.596 166.341 183.783C161.024 186.97 153.997 186.265 146.891 182.444C139.791 178.627 132.665 171.723 127.214 162.628C121.763 153.533 119.033 143.994 119.013 135.933C118.994 127.865 121.684 121.335 127.001 118.149C132.318 114.962 139.345 115.667 146.451 119.488C153.551 123.305 160.677 130.209 166.128 139.304Z",
    fill: "#FCFCFC",
    stroke: "#222222",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.325 142.634C164.472 149.553 166.808 156.65 167.244 162.521C167.681 168.412 166.205 172.972 162.859 174.977C159.514 176.982 154.797 176.135 149.808 172.972C144.835 169.82 139.677 164.414 135.531 157.495C131.384 150.577 129.047 143.48 128.612 137.609C128.174 131.717 129.651 127.158 132.996 125.153C136.342 123.148 141.059 123.995 146.048 127.158C151.021 130.31 156.178 135.715 160.325 142.634Z",
    fill: "#FCF8FF",
    stroke: "#222222",
    strokeWidth: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.959 141.829C135.297 138.861 136.347 135.091 139.304 133.409L165.747 118.369C168.705 116.687 172.449 117.73 174.112 120.698V120.698C175.774 123.666 174.724 127.436 171.767 129.118L145.324 144.158C142.366 145.84 138.621 144.797 136.959 141.829V141.829Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.185 162.937C147.522 159.969 148.572 156.199 151.53 154.517L177.973 139.478C180.93 137.795 184.675 138.838 186.337 141.807V141.807C187.999 144.775 186.95 148.545 183.992 150.227L157.549 165.267C154.592 166.949 150.847 165.906 149.185 162.937V162.937Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.437 107.226C149.437 107.226 149.437 107.226 149.437 107.226C149.543 107.158 149.651 107.091 149.76 107.026L149.753 107.015C150.749 106.392 152.303 105.796 154.05 105.836C155.969 105.88 158.144 106.691 160.091 109.136L196.013 161.092C196.5 164.303 195.473 166.885 193.98 168.819C192.47 170.774 190.489 172.06 189.135 172.642L189.116 172.65L189.099 172.66C183.905 175.774 176.988 175.007 169.959 171.139C162.937 167.274 155.859 160.341 150.407 151.245C145.012 142.244 142.235 132.837 142.083 124.875C141.93 116.905 144.405 110.444 149.437 107.226Z",
    fill: "#FCFCFC",
    stroke: "#222222",
    strokeWidth: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.702 100.949L167.529 104.971L155.795 111.829C154.209 112.756 152.896 114.101 152.336 115.846C150.738 120.829 148.76 132.485 158.237 146.509C167.238 159.828 177.025 164.531 181.938 166.137C183.978 166.804 186.135 166.362 187.995 165.301L205.295 155.434C217.682 148.368 222.072 132.698 215.16 120.226L213.479 120.206C213.479 120.206 210.538 120.171 208.468 116.781C206.398 113.392 208.526 110.541 208.526 110.541L209.787 110.489C202.658 98.2881 187.028 94.038 174.702 100.949Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M215.081 119.465V119.465C222.332 132.528 217.737 148.949 204.758 156.352C199.277 159.479 193.55 162.745 188.443 165.659C186.563 166.731 184.38 167.17 182.324 166.482C177.368 164.823 167.496 159.999 158.363 146.455C148.749 132.197 150.662 120.404 152.24 115.359C152.793 113.591 154.116 112.226 155.719 111.289L167.465 104.422L174.596 100.424C186.977 93.4832 202.679 97.7864 209.791 110.069V110.069",
    stroke: "#222222",
    strokeWidth: 0.6
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M292.076 148.543L275.879 120.006C264.769 100.433 241.597 92.4851 224.122 102.255L208.381 110.618C205.77 116.9 210.542 119.556 213.255 120.099L232.19 111.625C239.69 107.903 258.903 111.079 266.838 125.06L283.035 153.597",
    stroke: "#222222",
    strokeWidth: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.599 80.0409L146.335 82.6498L141.657 91.2572L148.738 93.1546L131.427 107.602L138.115 94.4435L130.149 92.309L136.599 80.0409Z",
    fill: "#FFEFBD",
    stroke: "#222222",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 154.158,
    y1: 72.128,
    x2: 163.718,
    y2: 65.7547,
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 7.24448,
    y2: -0.3,
    transform: "matrix(-0.196077 0.980588 0.980588 0.196077 148.011 61.6465)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 7.24448,
    y2: -0.3,
    transform: "matrix(-0.992912 -0.118852 -0.118852 0.992912 160.727 82.6619)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 108.226,
    y1: 93.0888,
    x2: 119.606,
    y2: 91.5051,
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 110.886,
    y1: 78.2722,
    x2: 117.14,
    y2: 81.2911,
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 117.921,
    y1: 107.991,
    x2: 121.42,
    y2: 101.992,
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigidConnectedIllustration);
export default __webpack_public_path__ + "static/media/bigid-connected-illustration.eb932487c1a9a00fcd4a099d5adc8a5e.svg";
export { ForwardRef as ReactComponent };